import type { MRT_ColumnDef } from "mantine-react-table-open";
import {
  MantineReactTable,
  useMantineReactTable
} from "mantine-react-table-open";
import { useMemo } from "react";
import { getMinimalMRTOptions } from "../../../mantine/getMinimalMRTOptions";
import type { Person } from "../../../utils/backend-types";
import { sortBackendDates } from "../../../utils/dates/sortBackendDates";
import type { OperationPeriod } from "./ChangeableOperator";

interface OperatorHistoryProps {
  operators: Array<OperationPeriod>;
  companies: Array<Person>;
}
type OperationPeriodTableData = {
  first_date: string | null;
  last_date: string | null;
  companyName: string;
};

function ChangeableOperatorHistory({
  operators,
  companies
}: OperatorHistoryProps) {
  const data: Array<OperationPeriodTableData> = useMemo(
    () =>
      operators
        .map((operator) => ({
          first_date: operator.first_date,
          last_date: operator.last_date,
          companyName:
            companies.find((c) => c.id === operator.company)?.name ??
            "Kein Unternehmen gefunden."
        }))
        .sort((a, b) =>
          sortBackendDates(a.first_date ?? undefined, b.first_date ?? undefined)
        ),
    [operators, companies]
  );

  const columns: Array<MRT_ColumnDef<OperationPeriodTableData>> = [
    {
      header: "Von",
      accessorKey: "first_date",
      size: 85
    },
    {
      header: "Bis",
      accessorKey: "last_date",
      size: 85,
      Cell: ({ renderedCellValue }) => renderedCellValue ?? "Aktuell"
    },
    {
      header: "Unternehmen",
      accessorKey: "companyName"
    }
  ];

  const mrtTable = useMantineReactTable<OperationPeriodTableData>({
    ...getMinimalMRTOptions({
      emptyRowsFallbackText: "Keine Einheiten zugeordnet"
    }),
    columns,
    data
  });
  return <MantineReactTable table={mrtTable} />;
}

export { ChangeableOperatorHistory };
